<template lang="pug">
#page_list_card.page
	Banner(v-bind:item='item_banner', classes='half')
	.container(v-if='flag_data_ready')
		template(v-for='item in items')
			CardNews(v-if='mode === "news"', v-bind:item='item')
			CardJudge(v-else, v-bind:item='item')
</template>

<script>
import { indexNews } from '@/router/api.js';
import DataJudge from '@/assets/data/judge.yaml';
import Banner from '@/components/Banner.vue';
import CardNews from '@/components/CardNews.vue';
import CardJudge from '@/components/CardJudge.vue';
export default {
	data() {
		return {
			flag_data_ready: false,
			item_banner: {},
			items: [],
		};
	},
	methods: {
		refresh: function () {
			this.item_banner = {
				media:
					this.mode === 'news'
						? 'assets/images/banner_1.jpg'
						: 'assets/images/banner_2.jpg',
				title:
					this.mode === 'news'
						? this.$t('nav_about_news_list')
						: this.$t('nav_competition_judge'),
			};

			if (this.mode === 'news') {
				indexNews().then(res => {
					this.items = res.data;
					this.flag_data_ready = true;
				});
			} else {
				this.items = DataJudge;
				this.flag_data_ready = true;
			}
		},
	},
	computed: {
		mode: function () {
			return this.$route.matched[0].props.default.mode;
		},
	},
	watch: {
		mode: {
			immediate: true,
			handler: function (value) {
				if (value) {
					this.refresh();
				}
			},
		},
		'$i18n.locale'() {
			this.refresh();
		},
	},
	beforeRouteLeave: function () {
		this.flag_data_ready = false;
	},
	components: {
		Banner,
		CardJudge,
		CardNews,
	},
};
</script>

<style lang="stylus">
#page_list_card
	padding-bottom: 2rem
	@media screen and (max-width: $screen-sm-max)
		padding-bottom: 1rem
</style>
